import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Country } from '@app/models/country';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { MemberService } from '@app/services/member.service';
import { CountryService } from '@app/services/shared/country.service';
import moment from 'moment';
import { ConfirmationService } from 'primeng/api';



@Component({
  selector: 'app-add-member',
  templateUrl: './add-member.component.html'
})

export class AddMemberComponent implements OnInit {
  institution;
  saveBtnDisabled = false;
memberform;
  countries: Country[] = [];
  accordionstatus;
  institutionid;
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode

  public maskdatum = [/[129]/, /[?0789]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  constructor(
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private confirmationService: ConfirmationService,
    private memberService: MemberService,
    private institutionService: InstitutionsService,
    private countryService: CountryService) { }

  ngOnInit() {
    this.countries = this.countryService.getCountryList();
    
    if(this.countries === null) {
      this.countries = JSON.parse(localStorage.getItem('countries'));
    }
    
    this.memberform = this.fb.group({
      institutionId: ['', ''], // Byt ut 4 mot ''. Institutions-idt får man via den inloggade användaren.
      initiatedDate: ['', Validators.required],
      member: this.fb.group({
        id: ['', ''],
        localId: ['', ''],
        givenName: ['', Validators.required],
        otherForeNames: ['', ''],
        middleName: ['', ''],
        familyName: ['', Validators.required],
        formerName: ['', ''],
        title: ['', ''],
        homeAddress: this.fb.group({
          id: ['', ''],
          careOf: ['', ''],
          street: ['', Validators.required],
          zipCode: ['', ''],
          city: ['', Validators.required],
          country: ['', Validators.required]
        }),
        workAddress: this.fb.group({
          id: ['', ''],
          careOf: ['', ''],
          street: ['', ''],
          zipCode: ['', ''],
          city: ['', ''],
          country: ['', '']
        }),
        otherAddress: this.fb.group({
          id: ['', ''],
          careOf: ['', ''],
          street: ['', ''],
          zipCode: ['', ''],
          city: ['', ''],
          country: ['', '']
        }),
        phone: ['', ''],
        phone2: ['', ''],
        phoneWork: ['', ''],
        phoneMobile: ['', ''],
        fax: ['', ''],
        email: ['', Validators.email],
        email2: ['', Validators.email],
        webSite: ['', ''],
        exitDate: ['', ''],
        createdDate: ['', ''],
        changedDate: ['', ''],
        mentorMemberId: ['', ''],
        mentorName: ['', ''],
        birthday: ['', ''],
        isSubscriber: [true, '']
      })
    });
    
    this.activatedRoute.queryParams.subscribe(qParams => {
      this.memberform.reset();
      this.institutionid = +qParams.institutionid;
      this.getInstitution(this.institutionid);
      this.memberform.patchValue({ institutionId: qParams.institutionid });
      this.memberform.get('member').get('birthday').setValue(qParams.birthday);
      this.memberform.get('member').get('isSubscriber').setValue(true);
    });
    
  }

  test(evt) {
    if (this.datePipe.transform(this.memberform.get('initiatedDate').value) < this.datePipe.transform(new Date())) {
    } else {
      alert('Invigningsdatum måste vara mindre än dagens datum.');
      this.memberform.patchValue({ initiatedDate: '' });
    }
  }

  saveForm() {
    this.saveBtnDisabled = true;
    const initiatedDate = moment(this.memberform.get('initiatedDate').value).add(3, 'h').format('YYYY-MM-DD HH:mm');
    this.memberform.patchValue({ initiatedDate: initiatedDate });
    this.memberService.addMember(this.memberform.value).subscribe(data => {
      if (data) {
        const memberdata = {
          givenName: this.memberform.get('member').get('givenName').value,
          familyName: this.memberform.get('member').get('familyName').value,
          memberId: data.body.memberid,
          password: data.body.generatedPassword,
          primaryInstitution: this.institution.shortName + ' ' + this.institution.name
        };
        this.memberService.newmemberdata.next(memberdata);
        this.router.navigate(['/kontoinformation'], { replaceUrl: true });
        this.saveBtnDisabled = false;
      }
    });
  }

  cancel() {
    if (this.memberform.dirty) {
       this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du avbryta utan att spara ändringarna?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
         this.memberform.reset();
          this.router.navigate(['']);
      },
      reject: () => {
      }
    });
    } else {
      this.memberform.reset();
      this.router.navigate(['']);
    }
  }

  getInstitution(id) {
    this.institutionService.getInstitutionByIdAsync(id).subscribe(resp => {
      this.institution = {
        shortName: resp.shortName,
        name: resp.name
      };
    });
  }
}
